/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ===== EX VAT / INC VAT — keep VAT lines visible after variant change ===== */
(function() {
  var VAT_RATE = 1.23;

  function formatMoney(pence) {
    return '€' + (pence / 100).toFixed(2);
  }

  function refreshVatDisplay() {
    var priceList = document.querySelector('.product-form__info-list .price-list');
    if (!priceList) return;

    // Find the main price span - try several possible selectors
    var mainPrice = priceList.querySelector('.price--highlight') ||
                    priceList.querySelector('.price:not(.price--compare):not(.price--inc-vat)');
    if (!mainPrice) return;

    // Add "+ VAT" label inline if missing
    if (!mainPrice.querySelector('.vat-label')) {
      var vatLabel = document.createElement('small');
      vatLabel.className = 'vat-label';
      vatLabel.textContent = '+ VAT';
      mainPrice.appendChild(document.createTextNode(' '));
      mainPrice.appendChild(vatLabel);
    }

    // Read current ex-VAT price from the DOM
    var priceText = mainPrice.textContent
      .replace(/Sale price/i, '')
      .replace(/Regular price/i, '')
      .replace(/\+\s*VAT/i, '')
.replace(/[^\d.,]/g, '')
.replace(/\./g, '')
.replace(',', '.');


    if (!priceText) return;
    var pricePence = Math.round(parseFloat(priceText) * 100);
    if (isNaN(pricePence) || pricePence === 0) return;

    var incVat = Math.round(pricePence * VAT_RATE);
    var incVatText = formatMoney(incVat) + ' Inc. VAT';

    // Update or create the inc-VAT span
    var incVatSpan = priceList.querySelector('.price--inc-vat');
    if (!incVatSpan) {
      incVatSpan = document.createElement('span');
      incVatSpan.className = 'price price--inc-vat';
      priceList.appendChild(incVatSpan);
    }
    if (incVatSpan.textContent !== incVatText) {
      incVatSpan.textContent = incVatText;
    }
  }

  function init() {
    var priceList = document.querySelector('.product-form__info-list .price-list');
    if (!priceList) return;

    refreshVatDisplay();

    var rafScheduled = false;
    var observer = new MutationObserver(function() {
      if (rafScheduled) return;
      rafScheduled = true;
      requestAnimationFrame(function() {
        rafScheduled = false;
        refreshVatDisplay();
      });
    });
    observer.observe(priceList, { childList: true, subtree: true, characterData: true });

    // Also re-run periodically as a safety net (Globo may replace the entire price-list element)
    setInterval(refreshVatDisplay, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();